<template>
  <ParagraphBody
    bodySize="large"
    :class="$style.login"
  >
    <span :class="$style.text">
      Already have an account?
    </span>
    <IconButton
      :class="$style.link"
      hasNoBackground
      :href="login"
      icon="arrowRight"
      iconPosition="right"
      text="Log in"
      @click="eventTracking"
    />
  </ParagraphBody>
</template>

<script>
import { IconButton, ParagraphBody } from '@jumpcloud/ui-components';
import { RouteGenerator } from 'client/util/Constants';
import EventHelper from 'client/GrowthEngineering/EventHelper';

const { login } = RouteGenerator;

export default {
  name: 'LoginLink',

  components: {
    IconButton,
    ParagraphBody,
  },

  data() {
    return {
      login,
    };
  },

  methods: {
    eventTracking() {
      EventHelper.triggerSignupLoginLinkClicked();
    },
  },
};
</script>

<style module scoped>
@value (max-width-medium) from '~css/breakpoints.css';

.login {
  align-items: center;
  display: flex;
  font-family: var(--sansSerifFont);
  justify-content: center;
}

.link {
  margin-inline-start: 0.5rem;
}

@media (max-width: max-width-medium) {
  .text {
    display: none;
  }
}
</style>
